export const pickAllowedFields = (obj: any, allowedFields: string[]): any => {
  if (Array.isArray(obj)) {
    return obj.map((item) => pickAllowedFields(item, allowedFields));
  }
  if (obj && typeof obj === 'object') {
    return Object.keys(obj)
      .filter((key) => allowedFields.includes(key))
      .reduce((acc, key) => {
        acc[key] = pickAllowedFields(obj[key], allowedFields);
        return acc;
      }, {} as Record<string, any>);
  }
  return obj;
};

export const removeFollowingFields = (
  obj: any,
  fieldsToRemove: string[]
): any => {
  if (Array.isArray(obj)) {
    return obj.map((item) => removeFollowingFields(item, fieldsToRemove));
  }
  if (obj && typeof obj === 'object') {
    return Object.keys(obj)
      .filter((key) => !fieldsToRemove.includes(key))
      .reduce((acc, key) => {
        acc[key] = removeFollowingFields(obj[key], fieldsToRemove);
        return acc;
      }, {} as Record<string, any>);
  }
  return obj;
};

export const deepOmit = (obj: any, keys: string[]): any => {
  if (Array.isArray(obj)) {
    return obj.map((item) => deepOmit(item, keys));
  } else if (obj && typeof obj === 'object') {
    return Object.keys(obj).reduce((acc, key) => {
      if (!keys.includes(key)) {
        acc[key] = deepOmit(obj[key], keys);
      }
      return acc;
    }, {} as any);
  }
  return obj;
};
